import { render, staticRenderFns } from "./add-return-modal.vue?vue&type=template&id=51ac9d0a"
import script from "./add-return-modal.vue?vue&type=script&lang=js"
export * from "./add-return-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports